import { render, staticRenderFns } from "./TeachingTimeTable.vue?vue&type=template&id=389f3e19&scoped=true&"
import script from "./TeachingTimeTable.vue?vue&type=script&lang=js&"
export * from "./TeachingTimeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389f3e19",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
